import React, { useEffect } from "react";
import useCarDeliveryConfigurator from "../../../../hooks/useCarDeliveryConfigurator";
import * as Styles from "./UscCarDeliveryConfigureDestination.styles";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import Container from "../../styles/atoms/Container";
import Icon from "../../../../../shared-components/toyota/styles/atoms/Icon";
import UscCarDeliverySelectDestination from "./UscCarDeliverySelectDestination";
import CarDeliverySelectedDestinationCard from "./CarDeliverySelectedDestinationCard";
import { useUscSelector } from "../../../../redux/store";
import { UscLabel } from "../../../../utils/labels";
import { trackCarDeliveryStepDestination } from "../../../../utils/tracking";

const UscCarDeliveryConfigureDestination = (): JSX.Element | null => {
    const {
        currentDealer,
        dealerResults,
        mapboxResults,
        onSearchInputChange,
        onSearchInputClear,
        loading,
        errorLabel,
        searchQuery,
        dealerLocationClick,
        mapboxLocationClick,
        removeDeliveryLocation,
        confirmDestinationConfiguration,
        handleBackButtonClick,
    } = useCarDeliveryConfigurator();

    const selectedDealer = useUscSelector((state) => state.carDelivery.tempDeliveryConfig);
    const uscEnv = useUscSelector((state) => state.vehicle.type);

    useEffect(() => {
        trackCarDeliveryStepDestination(uscEnv);
    }, []);
    const deliveryConfig = useUscSelector((state) => state.carDelivery.deliveryConfig);

    if (!currentDealer) return null;

    return (
        <Styles.Wrapper>
            <Container variant="container">
                <Styles.Grid>
                    <Styles.Destinations>
                        <div>
                            <Text variant="body-semibold" tag="h3">
                                <UscLabel label="uscCarDeliverySummaryStartingPointTitle" />
                            </Text>
                            <Styles.Card>
                                <Text variant="body-regular">{currentDealer.name}</Text>
                                <br />
                                {currentDealer.address.line1}
                                <br />
                                {currentDealer.address.zip} {currentDealer.address.city}
                            </Styles.Card>
                        </div>
                        <div>
                            <Text variant="body-semibold" tag="h3">
                                <UscLabel label="uscCarDeliverySummaryDestinationTitle" />
                            </Text>
                            {!selectedDealer?.address && !deliveryConfig && (
                                <Styles.DisabledCard>
                                    <UscLabel label="uscCarDeliveryNoDestinationSelected" />
                                </Styles.DisabledCard>
                            )}
                            {(selectedDealer?.address || deliveryConfig?.address) && (
                                <CarDeliverySelectedDestinationCard
                                    removeDeliveryLocation={removeDeliveryLocation}
                                    address={deliveryConfig?.address || selectedDealer?.address}
                                    dealerName={deliveryConfig?.dealerName || selectedDealer?.dealerName}
                                />
                            )}
                        </div>
                    </Styles.Destinations>
                    <Styles.LocationPicker>
                        <UscCarDeliverySelectDestination
                            onSearch={onSearchInputChange}
                            onClear={onSearchInputClear}
                            dealerResults={dealerResults}
                            loading={loading}
                            errorLabel={errorLabel}
                            searchQuery={searchQuery}
                            dealerLocationClick={dealerLocationClick}
                            mapboxLocationClick={mapboxLocationClick}
                            mapboxResults={mapboxResults}
                        />
                    </Styles.LocationPicker>
                    <Styles.Return>
                        <Button variant="icon-text" onClick={() => handleBackButtonClick()}>
                            <Icon variant="arrow-left" />
                            <UscLabel label="uscCarDeliveryBackButton" />
                        </Button>
                    </Styles.Return>
                    <Styles.Continue>
                        {(!!selectedDealer || !!deliveryConfig) && (
                            <Button
                                variant="primary"
                                size="fullwidth"
                                onClick={() => confirmDestinationConfiguration()}
                            >
                                <UscLabel label="uscCarDeliveryConfirmButton" />
                            </Button>
                        )}
                    </Styles.Continue>
                </Styles.Grid>
            </Container>
        </Styles.Wrapper>
    );
};

export default UscCarDeliveryConfigureDestination;
